import { createClient } from '@supabase/supabase-js'

// Client do FRONT: SOMENTE anon key (preso por RLS). Nunca service-role aqui.
const url = import.meta.env.VITE_SUPABASE_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(url ?? '', anon ?? '', {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
})

export const supabaseConfigured = Boolean(url && anon)

// Login social via Google (staff usa isto; sem atrito de magic link).
export async function signInWithGoogle(redirectTo?: string) {
  return supabase.auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: redirectTo ?? window.location.origin },
  })
}
